export default defineComponent({
  name: 'PriceDiscountLabel',
  props: {
    price: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onProductCard: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var discount = computed(function () {
      return Math.round((props.price.regular - props.price.special) / props.price.regular * 100);
    });
    var isDiscountThreeDigits = computed(function () {
      return discount > 99;
    });
    return {
      discount: discount,
      isDiscountThreeDigits: isDiscountThreeDigits
    };
  }
});